module.exports = __webpack_public_path__ + "static/media/thunderstorm-sun.535786eb.svg";